import * as Phaser from "phaser";
import { asError } from "catch-unknown";

import Sprite = Phaser.GameObjects.Sprite;

export class TexturesHelper {
    public static async getSnapshot(
        scene: Phaser.Scene,
        ...sprites: { sprite: Sprite; frame?: string | number }[]
    ): Promise<string> {
        if (!scene.game.renderer) {
            // In headless mode, we cannot take snapshots.
            // TODO: send a correct PNG????
            // TODO: send a correct PNG????
            // TODO: send a correct PNG????
            // TODO: send a correct PNG????
            // TODO: send a correct PNG????
            // TODO: send a correct PNG????
            return "";
        }
        // MERCADOLOGICA:
        // Os avatares HD8x possuem frames nativos de 256x256.
        //
        // No mapa eles sao reduzidos visualmente, mas para
        // pictureStore / camera-off / perfil queremos gerar
        // a imagem usando a resolucao nativa.
        //
        // Sprites classicos continuam com o comportamento
        // original de aproximadamente 32x32.
        const preparedSprites = sprites.map(({ sprite, frame }) => {
            const originalScaleX = sprite.scaleX;
            const originalScaleY = sprite.scaleY;
            const originalFrame = sprite.frame.name;

            if (frame !== undefined) {
                sprite.setFrame(frame);
            }

            const isHd8x =
                sprite.texture.key.startsWith("hd8x_");

            if (isHd8x) {
                sprite.setScale(1);
            }

            return {
                sprite,
                isHd8x,
                originalScaleX,
                originalScaleY,
                originalFrame,
            };
        });

        const snapshotWidth = Math.max(
            1,
            ...preparedSprites.map(
                ({ sprite }) =>
                    Math.ceil(sprite.displayWidth),
            ),
        );

        const snapshotHeight = Math.max(
            1,
            ...preparedSprites.map(
                ({ sprite }) =>
                    Math.ceil(sprite.displayHeight),
            ),
        );

        const rt = scene.make.renderTexture(
            {
                width: snapshotWidth,
                height: snapshotHeight,
            },
            false,
        );

        try {
            // MERCADOLOGICA:
            // Primeiro desenhamos TODOS os sprites enquanto
            // o HD8x ainda esta na escala nativa 1.0.
            //
            // O RenderTexture so deve ser finalizado antes
            // de restaurarmos a escala usada no mapa.
            for (const {
                sprite,
            } of preparedSprites) {

                rt.draw(
                    sprite,
                    snapshotWidth * 0.5,
                    snapshotHeight * 0.5,
                );
            }

            rt.render();

            // Agora que o snapshot ja foi renderizado,
            // devolvemos os sprites ao estado original.
            for (const {
                sprite,
                originalScaleX,
                originalScaleY,
                originalFrame,
            } of preparedSprites) {

                sprite.setScale(
                    originalScaleX,
                    originalScaleY,
                );

                sprite.setFrame(originalFrame);
            }
            return new Promise<string>((resolve, reject) => {
                try {
                    rt.snapshot(
                        (url) => {
                            if (url instanceof HTMLImageElement) {
                                resolve(url.src);
                            } else {
                                console.error("Unexpected color object received for snapshot", url);
                                resolve("");
                            }
                            rt.destroy();
                        },
                        "image/png",
                        1,
                    );
                } catch (error) {
                    rt.destroy();
                    reject(asError(error));
                }
            });
        } catch (error) {
            rt.destroy();
            throw new Error("Could not get the snapshot", { cause: error });
        }
    }

    public static createRectangleTexture(
        scene: Phaser.Scene,
        textureKey: string,
        width: number,
        height: number,
        color: number,
    ): void {
        const rectangleTexture = scene.add.graphics().fillStyle(color, 1).fillRect(0, 0, width, height);
        rectangleTexture.generateTexture(textureKey, width, height);
        rectangleTexture.destroy();
    }

    public static createCircleTexture(
        scene: Phaser.Scene,
        textureKey: string,
        radius: number,
        color: number,
        outlineColor?: number,
        outlineThickness?: number,
    ): void {
        const circleTexture = scene.add.graphics().fillStyle(color, 1).fillCircle(radius, radius, radius);
        if (outlineColor) {
            circleTexture.lineStyle(outlineThickness ?? 1, outlineColor).strokeCircle(radius, radius, radius);
        }
        circleTexture.generateTexture(textureKey, radius * 2, radius * 2);
        circleTexture.destroy();
    }

    public static async loadEntityImage(scene: Phaser.Scene, key: string, url: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            if (scene.textures.exists(key)) {
                resolve();
            }
            scene.load.once(`filecomplete-image-${key}`, () => {
                resolve();
            });
            scene.load.image(key, url);
            scene.load.start();
        });
    }
}
